/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { logoutUser } from '../../redux/actions/authActions';
import { Navigate } from 'react-router-dom';

const Logout = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        logoutUser(dispatch);
        localStorage.removeItem('token');
        localStorage.removeItem('refresh_token');
        <Navigate to="/login" />;
    }, []);

    return null;
};

export default Logout;
